import { SharedModal } from '..';
import { Typography } from '@mui/material';
import { FC, ReactNode } from 'react';

import * as Styled from './styled';

interface InfoModalProps {
	isOpen: boolean;
	image: ReactNode;
	onClose: () => void;
	title: string;
	description: string | ReactNode;
	buttons: ReactNode;
}

export const InfoModal: FC<InfoModalProps> = ({
	isOpen,
	onClose,
	image,
	title,
	description,
	buttons,
}) => {
	return (
		<SharedModal isOpen={isOpen} handleClose={onClose}>
			<Styled.ModalContent
				className="not-rtl-able"
				sx={{
					width: { xs: '100%', sm: '438px' },
				}}
			>
				{image}
				<Typography
					variant="h3"
					sx={{ fontSize: '24px', fontWeight: '700', marginTop: '32px', textAlign: 'center' }}
				>
					{title}
				</Typography>
				<Typography sx={{ color: '#9FA6B3', marginTop: '8px', textAlign: 'center' }}>
					{description}
				</Typography>
				<Styled.ModalButtons className="not-rtl-able" sx={{ gap: { xs: '0', sm: '16px' } }}>
					{buttons}
				</Styled.ModalButtons>
			</Styled.ModalContent>
		</SharedModal>
	);
};
